import React, { useEffect, useState } from "react";
import "../../Styles/Address.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { deleteUser, getUser } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import Header from "../Components/Header";

const Loader = () => {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-header"></div>
      <div className="skeleton-add-btn"></div>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="skeleton-address-card">
          <div className="skeleton-name"></div>
          <div className="skeleton-address-line"></div>
          <div className="skeleton-address-line"></div>
          <div className="skeleton-phone"></div>
          <div className="skeleton-actions">
            <div className="skeleton-icon"></div>
            <div className="skeleton-icon"></div>
          </div>
        </div>
      ))}
      <style>
        {`
          .skeleton-loader {
            width: 90%;
            margin: 20px auto;
            padding: 20px;
          }
          .skeleton-header {
            height: 40px;
            width: 200px;
            background: #e0e0e0;
            margin: 0 auto 20px;
            border-radius: 4px;
            animation: pulse 1.5s ease-in-out infinite;
          }
          .skeleton-add-btn {
            height: 40px;
            width: 180px;
            background: #f0f0f0;
            margin-bottom: 20px;
            border-radius: 33px;
            animation: pulse 1.5s ease-in-out infinite;
          }
          .skeleton-address-card {
            background: #fff;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .skeleton-name {
            height: 24px;
            width: 150px;
            background: #f0f0f0;
            margin-bottom: 15px;
            border-radius: 4px;
            animation: pulse 1.5s ease-in-out infinite;
          }
          .skeleton-address-line {
            height: 16px;
            background: #f0f0f0;
            margin-bottom: 8px;
            border-radius: 4px;
            animation: pulse 1.5s ease-in-out infinite;
          }
          .skeleton-phone {
            height: 16px;
            width: 120px;
            background: #f0f0f0;
            margin-bottom: 15px;
            border-radius: 4px;
            animation: pulse 1.5s ease-in-out infinite;
          }
          .skeleton-actions {
            display: flex;
            gap: 15px;
          }
          .skeleton-icon {
            height: 20px;
            width: 20px;
            background: #f0f0f0;
            border-radius: 50%;
            animation: pulse 1.5s ease-in-out infinite;
          }
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
    </div>
  );
};

export const Address = () => {
  const navigate = useNavigate();
  const [address, setAddress] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const { tokenDetails } = useSelector((state) => state.user);
  const token = tokenDetails;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUser(token);
        console.log("address :", response);
        if (response.success) {
          setAddress(response.data);
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        //toast.error("An error occurred while fetching addresses.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [refreshKey, token]);

  if (isLoading) {
    return <Loader />;
  }

  const handleDeleteAddress = async (id) => {
    const formData = new FormData();
    formData.append("addressId", id);

    console.log("Deleting address with ID:", id);
    const result = await deleteUser(formData, token);
    if (result.success) {
      toast.success("Address deleted successfully");
      setRefreshKey((prev) => prev + 1);
    }
  };

  const handleEditAddress = (id) => {
    console.log("Id : ", id);
    const addressToEdit = address.find((item) => item.id === id);
    console.log("addressToEdit : ", addressToEdit);
    navigate("/add-addresses", { state: { address: addressToEdit } });
  };

  return (
    <div className="add-address-container body-container default is-ctl-home-page is-ctl-landingpage is-ctl-navigation is-act-home">
      
      <h3 style={{ textAlign: "center", marginTop: "13px", fontSize: "34px", borderBottom: "3px solid grey", paddingBottom: "10px" }}>
        Address
      </h3>
      <div className="container1" style={{ margin: "30px auto" }}>
        <h2 className="title1">Select Delivery Address</h2>
        <button 
          className="add-btn1" 
          onClick={() => navigate("/add-addresses")} 
          style={{ backgroundColor: "black", borderRadius: "33px" }}
        >
          + Add New Address
        </button>
        <div className="address-card1">
          {address.map((details) => (
            <div key={details.id}>
              <h3 className="name1">{details.name}</h3>
              <p className="address1">
                {details.address}, {details.city}, {details.state},
                {details.country_name}, {details.pincode}
              </p>
              <p className="phone1">{details.mobile_no}</p>
              <div className="actions1">
                <FaEdit
                  className="icon edit-icon1"
                  title="Edit"
                  onClick={() => handleEditAddress(details.id)}
                  style={{ width: "0.55em", height: "0.55em" }}
                />
                <FaTrash
                  className="icon delete-icon1"
                  title="Delete"
                  onClick={() => handleDeleteAddress(details.id)}
                  style={{ width: "0.55em", height: "0.55em" }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};